import { Modal } from '@pmi/dsm-react';
import styles from './embedVideoModal.module.scss';
import EmbedVideo from '../EmbedVideo/EmbedVideo';

interface EmbedVideoModalProps {
  videoUrl: string;
  transcript: string;
  onCancel: () => void;
}

export default function EmbedVideoModal({
  onCancel,
  videoUrl,
  transcript,
}: EmbedVideoModalProps) {
  return (
    <Modal
      show
      variant="dialog"
      onClose={onCancel}
      customClassName={`${styles.videoModal}`}
    >
      <h1 className={styles.modalHeader}>Overview Video</h1>
      <EmbedVideo url={videoUrl} transcript={transcript} onModal />
    </Modal>
  );
}
